import { useDroppable } from '../adapters/dndAdapter';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { getListClass } from '../utils/dndClassNames';

/**
 * Droppable - Zona de drop sin ordenamiento automático
 *
 * Usado para zonas de destino que no necesitan reordenamiento interno,
 * como columnas de calendario o zonas de "soltar aquí"
 *
 * @param {string} droppableId - ID único de la zona
 * @param {React.ReactNode|Function} children - Contenido o render function
 * @param {string} [className] - Clase CSS adicional
 * @param {boolean} [disabled=false] - Deshabilitar drop
 * @param {Object} [data] - Datos adicionales para la zona
 *
 * Si children es función, recibe:
 * - isOver: boolean - hay un elemento sobre esta zona
 * - active: objeto del elemento siendo arrastrado
 * - setNodeRef: ref para el elemento
 */
const Droppable = ({ droppableId, children, className, disabled = false, data }) => {
  const { setNodeRef, isOver, active } = useDroppable({
    id: droppableId,
    disabled,
    data,
  });

  // Si children es función, pasarle el estado
  if (typeof children === 'function') {
    return children({
      isOver,
      active,
      setNodeRef,
    });
  }

  // Render por defecto
  return (
    <div ref={setNodeRef} className={clsx(className, getListClass({ isOver }))}>
      {children}
    </div>
  );
};

Droppable.propTypes = {
  droppableId: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  data: PropTypes.object,
};

export default Droppable;
